import authorizedAxios from "../../helpers/authorizedAxios";
import { showToast } from "../../utils/helpers/ShowToast";

export const SET_OPERATIONAL_EXPENSES = "SET_OPERATIONAL_EXPENSES";
export const SET_OPERATIONAL_EXPENSE_DETAIL = "SET_OPERATIONAL_EXPENSE_DETAIL";
export const SET_OPERATIONAL_EXPENSE_LOADING = "SET_OPERATIONAL_EXPENSE_LOADING";
export const SET_OPERATIONAL_EXPENSE_ACTION_LOADING = "SET_OPERATIONAL_EXPENSE_ACTION_LOADING";
export const SET_OPERATIONAL_EXPENSE_ERROR = "SET_OPERATIONAL_EXPENSE_ERROR";

const errorMessage = (error, fallback) => error?.response?.data?.message || error?.userMessage || error?.message || fallback;

const setError = (dispatch, error, fallback) => {
  dispatch({ type: SET_OPERATIONAL_EXPENSE_ERROR, error: errorMessage(error, fallback) });
};

const mutate = (request, messages) => async (dispatch) => {
  dispatch({ type: SET_OPERATIONAL_EXPENSE_ACTION_LOADING, status: true });
  try {
    const response = await showToast(request(), {
      ...messages,
      error: (error) => errorMessage(error, messages.error),
    });
    return response?.data?.data ?? true;
  } catch (error) {
    setError(dispatch, error, messages.error);
    return null;
  } finally {
    dispatch({ type: SET_OPERATIONAL_EXPENSE_ACTION_LOADING, status: false });
  }
};

export const fetchOperationalExpenses = (params = {}) => async (dispatch) => {
  dispatch({ type: SET_OPERATIONAL_EXPENSE_LOADING, status: true });
  try {
    const response = await authorizedAxios.get("/operational-expenses", { params });
    dispatch({ type: SET_OPERATIONAL_EXPENSES, data: response?.data?.data });
    return response?.data?.data;
  } catch (error) {
    setError(dispatch, error, "Data biaya operasional gagal dimuat.");
    return null;
  } finally {
    dispatch({ type: SET_OPERATIONAL_EXPENSE_LOADING, status: false });
  }
};

export const fetchOperationalExpenseDetail = (id) => async (dispatch) => {
  dispatch({ type: SET_OPERATIONAL_EXPENSE_LOADING, status: true });
  try {
    const response = await authorizedAxios.get(`/operational-expenses/${id}`);
    dispatch({ type: SET_OPERATIONAL_EXPENSE_DETAIL, data: response?.data?.data });
    return response?.data?.data;
  } catch (error) {
    setError(dispatch, error, "Detail biaya operasional gagal dimuat.");
    return null;
  } finally {
    dispatch({ type: SET_OPERATIONAL_EXPENSE_LOADING, status: false });
  }
};

export const addOperationalExpense = (payload) => mutate(
  () => authorizedAxios.post("/operational-expenses", payload),
  {
    loading: "Mencatat biaya operasional...",
    success: "Biaya operasional berhasil dicatat.",
    error: "Biaya operasional gagal dicatat.",
  },
);

export const updateOperationalExpense = (id, payload) => mutate(
  () => authorizedAxios.put(`/operational-expenses/${id}`, payload),
  {
    loading: "Memperbarui informasi biaya...",
    success: "Informasi biaya operasional berhasil diperbarui.",
    error: "Biaya operasional gagal diperbarui.",
  },
);

export const cancelOperationalExpense = (id, reason) => mutate(
  () => authorizedAxios.post(`/operational-expenses/${id}/cancel`, { reason }),
  {
    loading: "Membatalkan biaya operasional...",
    success: "Biaya dibatalkan dan saldo Kas & Bank dikembalikan.",
    error: "Biaya operasional gagal dibatalkan.",
  },
);
